// extracted by mini-css-extract-plugin
module.exports = {"dateContent":"_3fMk0GGP","date":"_2KuEn-UJ","placeholderDate":"_3zwgG7Xx","copy":"_2dQ5n8ny"};
    if(module.hot) {
      // 1746735879475
      var cssReload = require("!../../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  